import { render, staticRenderFns } from "./Outpatient.vue?vue&type=template&id=44bc5148"
import script from "./Outpatient.vue?vue&type=script&lang=js"
export * from "./Outpatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports